import { render } from "./CardPasswordChange.vue?vue&type=template&id=671d4a1e"
import script from "./CardPasswordChange.vue?vue&type=script&lang=js"
export * from "./CardPasswordChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__